import React from "react";
import { Link } from "react-router-dom";
import GridShape from "../common/GridShape";
import PageMeta from "../common/PageMeta";
import { appConfigService } from "../../services/AppConfigService";

// // Get the base URL based on environment
// const getWebUrl = () => {
//   switch (process.env.REACT_APP_ENV) {
//     case 'LOCAL':
//       return 'http://localhost:4321';
//     case 'DEVELOPMENT':
//       return 'https://www.001-pdfconvertone-dev.pdfconvertone.com';
//     default :
//       return 'https://www.pdfconvertone.com';
//   }
// };

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  backLink?: {
    to: string;
    label: string;
  };
  metaTitle: string;
  metaDescription: string;
}

export default function AuthLayout({
  children,
  title,
  subtitle,
  backLink,
  metaTitle,
  metaDescription
}: AuthLayoutProps) {
  // Store web URL to use in the component
  //const webUrl = getWebUrl();

  const config = appConfigService.getConfig();
  const webUrl = config.webAppUrl;
  console.log('config is: ', config);

  return (
    <>
      <PageMeta
        title={metaTitle}
        description={metaDescription}
      />
      <div className="relative flex w-full h-screen px-4 py-6 overflow-hidden bg-white z-1 dark:bg-gray-900 sm:p-0">
        <div className="flex flex-col flex-1 p-6 rounded-2xl sm:rounded-none sm:border-0 sm:p-8">
          {backLink && (
            <div className="w-full max-w-md pt-10 mx-auto">
              <Link
                to={backLink.to}
                className="inline-flex items-center text-sm text-gray-500 transition-colors hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
              >
                <svg
                  className="stroke-current"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M12.7083 5L7.5 10.2083L12.7083 15.4167"
                    stroke=""
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {backLink.label}
              </Link>
            </div>
          )}
          <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
            <div>
              <div className="mb-5 sm:mb-8">
                <h1 className="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
                  {title}
                </h1>
                {subtitle && (
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {subtitle}
                  </p>
                )}
              </div>
              
              {children}
            </div>
          </div>
        </div>
        <div className="relative items-center justify-center flex-1 hidden p-8 z-1 bg-brand-950 dark:bg-white/5 lg:flex">
          <GridShape />
          <div className="flex flex-col items-center max-w-xs">
            <Link to={webUrl} className="block mb-4">
              <img src="/images/logo/auth-logo.svg" alt="Logo" />
            </Link>
            <p className="text-center text-gray-400 dark:text-white/60">
              PDF ConvertOne - Convert your bank statement PDF files to CSV
            </p>
            <a 
              href={webUrl} 
              className="mt-2 text-sm text-brand-400 hover:text-brand-500 transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              Return to pdfconvertone.com
            </a>
          </div>
        </div>
      </div>
    </>
  );
}